import React, { FC } from 'react';

interface AccessInstructionsProps {}

const AccessInstructions: FC<AccessInstructionsProps> = () => {
  return (
    <div>
      <h3>Steps to Join RBAC Groups in CAMP</h3>
      <p>
        You should be able to start using GSC shortly after following these steps:
      </p>
      <p>
        <a href="https://dpc.microsoft.com/camp/onboardRequest?linkId=92ccef5e-77d7-4b9e-af70-a31f68b2e2f6">Request access or view RBAC status: Click here!</a>
      </p>
      <ol>
        <li>Go to “Requests” in the sidebar, then click “Self Request Onboarding”.</li>
        <li>Fill out the form. Group Name: “Gaming RBAC” (if in Gaming) or “Gaming Partner RBAC” (if a partner).</li>
        <li>Panel Name: Select your closest organization (e.g., “Gaming – GPSO Data Access” for GPSO).</li>
        <li>Access Levels: Typically, these are “GG-Consumer Confidential” for general users or “GG-Consumer Sensitive Financial” for financial data.</li>
        <li>Justification: Explain why you need access.</li>
      </ol>
    </div>
  );
}

export default AccessInstructions;
